import { render, staticRenderFns } from "./UploadArquivo.vue?vue&type=template&id=6fd54e90&"
import script from "./UploadArquivo.vue?vue&type=script&lang=js&"
export * from "./UploadArquivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports